import { Component } from '@angular/core';
export type SetQuantityDialogGaebComponentDialogData = undefined
export type SetQuantityDialogGaebComponentDialogReturnData = undefined | boolean

@Component({
    selector: 'app-set-quantity-dialog-gaeb',
    templateUrl: './set-quantity-dialog-gaeb.component.html',
    styleUrls: ['./set-quantity-dialog-gaeb.component.scss'],
})
export class SetQuantityDialogGaebComponent {
    constructor() {
    }
}
